// 记录列表的查询条件
const recordsQuery = {
  state: {
    missionManagementQuery: {}, // 任务管理查询条件
    problemQuery: {}, // 问题跟踪查询条件
    pointManagementQuery: {}, // 点位管理查询条件
    workbenchQuery: {}, // 抽查工作台查询条件
    orderSearchQuery: {}, // 工单查询 查询条件
    equipmentManageQuery: {}, // 设备管理查询条件
    facilityQuery: {}, // 设施管理查询条件
    guideConfigQuery: {}, // 故障指导配置
    generatrixQuery: null, // 动线管理查询条件
    docResourceQuery: {}, // 资料管理查询条件
    reportOrderCreationQuery: {}, // 资料管理查询条件
    reportOrderStationProjectCodesKey: 'reportorder_station_projectcodes',
    AcceptInitQuery: {}, // 承查设施设备查询条件
    remoteMonitorQuery: {} // 远程监控设备查询条件
  },
  mutations: {
    setMissionManagementQuery (state, e) { // 存任务管理列表查询条件，实现进入详情后返回记住查询参数
      state.missionManagementQuery = e
    },
    setProblemQuery (state, e) { // 存问题跟踪列表查询条件，实现进入详情后返回记住查询参数
      state.problemQuery = e
    },
    setPointManagementQuery (state, e) { // 存点位管理列表查询条件
      state.pointManagementQuery = e
    },
    setWorkbenchQuery (state, e) { // 存抽查工作台查询条件
      state.workbenchQuery = e
    },
    setOrderSearchQuery (state, e) { // 存抽查询工单查询条件
      state.orderSearchQuery = e
    },
    setEquipmentManageQuery (state, e) { // 存抽查工作台查询条件
      state.equipmentManageQuery = e
    },
    FacilityManageQuery (state, e) { // 设施管理查询条件
      state.facilityQuery = e
    },
    FaultGuideConfigQuery (state, e) { // 故障指导配置
      state.guideConfigQuery = e
    },
    setGeneratrixQuery (state, e) { // 动线管理查询条件
      state.generatrixQuery = e
    },
    setDocResourceQuery (state, e) { // 资料管理查询条件
      state.docResourceQuery = e
    },
    setReportOrderCreationQuery (state, e) { // 报事工单查询
      state.reportOrderCreationQuery = e
    },
    setAcceptInitQuery (state, e) { // 资料管理查询条件
      state.AcceptInitQuery = e
    },
    setRemoteMonitorQuery (state, e) { // 远程监控设备查询条件
      state.remoteMonitorQuery = e
    }

  }
}

export default recordsQuery
